var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g2, _path13, _path14, _path15, _path16, _path17, _g3, _path18, _path19, _path20, _path21, _g4, _path22, _path23, _path24, _path25, _g5, _path26, _path27, _path28, _path29, _g6, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g7, _g8, _path38, _path39, _path40, _path41, _ellipse, _path42, _g9, _path43, _path44, _path45, _path46, _path47, _g0, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _g1, _path64, _path65, _path66, _g10, _path67, _path68, _path69, _g11, _path70, _path71, _path72, _g12, _path73, _path74, _path75, _g13, _path76, _path77, _path78, _g14, _path79, _path80, _path81, _g15, _path82, _path83, _path84, _g16, _path85, _path86, _path87, _g17, _path88, _path89, _path90, _g18, _path91, _path92, _path93, _g19, _path94, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfinandinhoCadastroSucesso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 325,
    viewBox: "0 0 350 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M304.1 99.1399C339.297 168.464 284.392 222.702 235.087 247.736C185.781 272.769 24.4649 293.94 35.71 206.272C41.0364 164.746 112.133 138.784 161.439 113.751C210.744 88.7175 268.902 29.8154 304.1 99.1399Z",
    fill: "#F1ECF7"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2042_2)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187.916 169.479L191.112 163.84C191.112 163.84 185.412 160.945 177.275 161.806C177.337 161.649 144.388 163.527 141.404 169.227C141.315 169.378 143.768 175.536 143.768 175.536L162.74 173.888L187.916 169.479Z",
    fill: "#ADADAD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2042_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.106 163.84C204.546 171.272 213.705 185.813 213.968 203.003C214.365 228.86 194.47 250.906 169.535 252.241C144.606 253.577 124.074 233.694 123.678 207.837C123.443 192.413 130.428 178.347 141.393 169.221C142.538 169.356 143.684 169.456 144.818 169.523C160.432 170.401 176.766 167.964 191.106 163.84Z",
    fill: "url(#paint0_linear_2042_2)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M123.683 207.842C123.449 192.419 130.434 178.353 141.398 169.227C141.722 169.266 142.046 169.294 142.371 169.328C133.681 178.347 128.355 190.809 128.556 204.31C128.953 230.168 149.479 250.051 174.414 248.715C182.316 248.29 189.709 245.787 196.113 241.741C188.72 247.843 179.538 251.71 169.541 252.247C144.606 253.577 124.074 233.699 123.683 207.842Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M175.917 173.2C175.917 173.2 176.381 173.876 177.074 175.134C177.415 175.765 177.829 176.536 178.248 177.441C178.673 178.347 179.142 179.375 179.583 180.526C179.818 181.096 180.042 181.7 180.265 182.326C180.5 182.952 180.712 183.605 180.919 184.282C181.355 185.628 181.768 187.065 182.115 188.573C182.277 189.328 182.467 190.093 182.618 190.876C182.763 191.658 182.908 192.452 183.043 193.256C183.149 194.061 183.255 194.877 183.361 195.693C183.462 196.509 183.501 197.336 183.573 198.163C183.646 198.99 183.657 199.817 183.68 200.639C183.702 201.454 183.719 202.304 183.691 203.097C183.685 204.69 183.579 206.283 183.501 207.831C183.439 208.596 183.395 209.356 183.322 210.094C183.249 210.832 183.154 211.552 183.076 212.251C182.992 212.95 182.892 213.631 182.791 214.291C182.685 214.95 182.556 215.582 182.45 216.185C182.333 216.789 182.204 217.37 182.087 217.918C181.947 218.465 181.813 218.979 181.685 219.466C181.416 220.432 181.143 221.265 180.88 221.936C180.377 223.288 179.93 223.986 179.93 223.986C179.93 223.986 180.193 223.21 180.438 221.813C180.573 221.12 180.684 220.265 180.818 219.292C180.936 218.314 181.036 217.208 181.137 216.006C181.226 214.799 181.293 213.492 181.355 212.106C181.411 210.72 181.422 209.261 181.467 207.747C181.467 206.992 181.472 206.227 181.472 205.456C181.467 204.673 181.455 203.88 181.45 203.081C181.455 202.27 181.411 201.51 181.388 200.706C181.366 199.912 181.344 199.113 181.271 198.314C181.204 197.52 181.176 196.716 181.087 195.928C181.003 195.134 180.913 194.346 180.83 193.564C180.712 192.787 180.606 192.01 180.505 191.245C180.399 190.479 180.248 189.73 180.125 188.987C179.84 187.512 179.578 186.075 179.259 184.734C179.114 184.058 178.946 183.404 178.79 182.773C178.639 182.136 178.488 181.527 178.326 180.945C178.013 179.777 177.706 178.704 177.421 177.76C177.13 176.816 176.873 175.994 176.65 175.318C176.42 174.642 176.236 174.116 176.113 173.753C175.99 173.39 175.917 173.2 175.917 173.2Z",
    fill: "#662D91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M185.815 186.249C189.218 189.216 190.459 194.899 188.576 198.945C186.698 202.991 182.417 203.868 179.014 200.901C175.611 197.934 174.376 192.25 176.253 188.204C178.131 184.159 182.412 183.287 185.815 186.249Z",
    fill: "#CCA244"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M179.019 200.89C175.616 197.923 174.375 192.24 176.259 188.194C176.655 187.339 177.158 186.629 177.74 186.064C179.137 186.092 180.595 186.662 181.92 187.819C185.323 190.787 186.563 196.47 184.68 200.516C184.283 201.371 183.78 202.081 183.199 202.645C181.802 202.617 180.344 202.047 179.019 200.89Z",
    fill: "#FFCA55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M180.243 194.179C179.058 193.603 177.639 192.441 177.667 190.798C177.689 189.367 179.03 188.657 180.181 189.037C182.869 189.92 183.763 195.894 180.243 194.179Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M178.416 202.198C182.423 205.691 187.458 204.657 189.671 199.895C191.878 195.134 190.425 188.445 186.418 184.952C182.411 181.46 177.376 182.493 175.163 187.255C172.956 192.022 174.409 198.711 178.416 202.198ZM176.253 188.205C178.131 184.159 182.411 183.281 185.815 186.249C189.218 189.216 190.459 194.899 188.575 198.945C186.698 202.991 182.417 203.869 179.014 200.901C175.61 197.94 174.375 192.251 176.253 188.205Z",
    fill: "#662D91"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M178.885 201.058C175.426 198.04 174.163 192.239 176.069 188.121C176.996 186.12 178.528 184.801 180.377 184.41C182.261 184.008 184.239 184.611 185.949 186.098C189.408 189.116 190.671 194.916 188.765 199.035C187.838 201.035 186.306 202.354 184.457 202.745C184.233 202.796 184.01 202.824 183.786 202.846C182.104 202.991 180.388 202.371 178.885 201.058ZM185.686 186.405C184.077 185.003 182.221 184.433 180.467 184.807C178.745 185.176 177.315 186.411 176.437 188.294C174.599 192.256 175.817 197.85 179.148 200.756C180.757 202.159 182.613 202.729 184.367 202.354C186.088 201.985 187.519 200.75 188.396 198.867C190.235 194.899 189.022 189.311 185.686 186.405Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 47,
    width: 156,
    height: 134
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M102.018 47.1538L241.869 65.5955L226.654 180.972L86.8035 162.531L102.018 47.1538Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 15,
    width: 184,
    height: 162
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7482 25.7105L246.023 15.6497L254.702 166.163L80.4266 176.224L71.7482 25.7105Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 15,
    width: 184,
    height: 162
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7482 25.7105L246.023 15.6497L254.702 166.163L80.4266 176.224L71.7482 25.7105Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 15,
    width: 184,
    height: 162
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7482 25.7105L246.023 15.6497L254.702 166.163L80.4266 176.224L71.7482 25.7105Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 58,
    width: 138,
    height: 114
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0656 120.109C100.046 172.85 153.731 171.829 165.984 170.902C167.64 170.773 169.283 170.642 170.938 170.527C183.19 169.6 236.405 162.555 232.425 109.814C228.387 56.4534 173.49 58.1347 162.098 59.0642C160.722 59.1745 159.334 59.2694 157.96 59.366C146.557 60.169 92.028 66.7481 96.0656 120.109Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2042_2)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2042_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.9383 40.3876L80.0973 199.162L257.509 188.918L248.348 30.1567L70.9383 40.3876Z",
    fill: "url(#paint1_linear_2042_2)"
  }))))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 55,
    width: 139,
    height: 112
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M108.088 55.0684L233.954 71.6659L221.506 166.065L95.6401 149.468L108.088 55.0684Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 15,
    width: 184,
    height: 162
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7474 25.7102L246.023 15.6495L254.701 166.163L80.4257 176.224L71.7474 25.7102Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 15,
    width: 184,
    height: 162
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7474 25.7102L246.023 15.6495L254.701 166.163L80.4257 176.224L71.7474 25.7102Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 15,
    width: 184,
    height: 162
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7474 25.7102L246.023 15.6495L254.701 166.163L80.4257 176.224L71.7474 25.7102Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 65,
    width: 125,
    height: 85
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M226.455 113.987C227.234 124.303 225.96 133.333 222.638 141.037C217.878 133.407 211.037 127.641 202.153 123.788C188.024 117.659 172.872 118.023 167.019 118.474L166.625 118.506C165.923 118.566 165.236 118.614 164.519 118.673C163.818 118.719 163.116 118.779 162.415 118.826L162.023 118.844C156.172 119.281 141.136 121.189 128.093 129.376C119.884 134.518 113.981 141.243 110.433 149.501C105.994 142.385 103.353 133.644 102.587 123.331C100.972 101.97 108.194 86.0817 124.066 76.1419C137.121 67.9703 152.143 66.0607 158.009 65.6253L158.388 65.592C159.091 65.5318 159.792 65.4852 160.493 65.4387C161.195 65.3785 161.898 65.3184 162.599 65.2718L162.992 65.2403C168.846 64.7895 183.997 64.4253 198.126 70.5542C215.304 78.0022 224.839 92.6263 226.455 113.987Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_2042_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.6577 55.3198L96.3521 171.46L239.572 163.195L232.877 47.0553L89.6577 55.3198Z",
    fill: "url(#paint2_linear_2042_2)"
  }))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 69,
    width: 130,
    height: 94
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M109.741 69.5144L228.614 85.1898L218.471 162.108L99.5978 146.432L109.741 69.5144Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 15,
    width: 184,
    height: 162
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7482 25.7102L246.023 15.6495L254.702 166.163L80.4266 176.224L71.7482 25.7102Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 15,
    width: 184,
    height: 162
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7482 25.7102L246.023 15.6495L254.702 166.163L80.4266 176.224L71.7482 25.7102Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 15,
    width: 184,
    height: 162
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7482 25.7102L246.023 15.6495L254.702 166.163L80.4266 176.224L71.7482 25.7102Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_2042_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.629 145.243L138.075 149.575C121.205 150.852 106.508 138.285 105.236 121.485C103.962 104.698 116.606 90.0533 133.488 88.7919L191.03 84.4441C207.9 83.1672 222.608 95.7502 223.869 112.535C225.143 129.321 212.499 143.966 195.629 145.243Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.108 127.155C169.964 128.216 165.173 128.672 162.014 128.225C162.014 128.225 161.243 137.456 167.688 137.011C174.43 136.548 173.108 127.155 173.108 127.155Z",
    fill: "#666666"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 181,
    y: 111,
    width: 19,
    height: 10
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M182.509 111.124L199.99 113.429L199.068 120.422L181.587 118.117L182.509 111.124Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 15,
    width: 184,
    height: 162
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7482 25.7104L246.023 15.6496L254.702 166.163L80.4266 176.224L71.7482 25.7104Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 15,
    width: 184,
    height: 162
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7482 25.7104L246.023 15.6496L254.702 166.163L80.4266 176.224L71.7482 25.7104Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 15,
    width: 184,
    height: 162
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7482 25.7104L246.023 15.6496L254.702 166.163L80.4266 176.224L71.7482 25.7104Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_2042_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.181 112.379C193.174 112.433 195.109 112.828 196.934 113.527C198.177 114.01 198.784 115.41 198.303 116.639C197.819 117.881 196.405 118.487 195.177 118.005C192.559 116.993 189.542 116.901 186.871 117.771C185.593 118.187 184.239 117.494 183.823 116.23C183.406 114.966 184.098 113.613 185.376 113.197C187.234 112.595 189.187 112.324 191.181 112.379Z",
    fill: "#666666"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 130,
    y: 111,
    width: 21,
    height: 17
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M132.639 111.662L150.121 113.967L148.277 127.952L130.795 125.647L132.639 111.662Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 15,
    width: 184,
    height: 162
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7481 25.7102L246.023 15.6495L254.702 166.163L80.4264 176.224L71.7481 25.7102Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 15,
    width: 184,
    height: 162
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7481 25.7102L246.023 15.6495L254.702 166.163L80.4264 176.224L71.7481 25.7102Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 15,
    width: 184,
    height: 162
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7481 25.7102L246.023 15.6495L254.702 166.163L80.4264 176.224L71.7481 25.7102Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_2042_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.305 116.647C142.266 116.322 144.239 116.318 146.168 116.655C147.485 116.885 148.362 118.14 148.134 119.444C147.893 120.746 146.638 121.622 145.334 121.395C142.564 120.905 139.593 121.416 137.133 122.787C135.979 123.427 134.504 123.024 133.85 121.867C133.183 120.71 133.598 119.25 134.768 118.598C136.478 117.643 138.343 116.985 140.305 116.647Z",
    fill: "#666666"
  })))))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M230.986 72.4367L227.85 33.1774C231.823 31.6362 234.318 27.287 233.092 22.7415C232.175 19.3412 229.18 16.7891 225.678 16.4264C220.095 15.8466 215.614 20.4448 216.039 25.7638C216.354 29.6824 219.23 32.7904 222.894 33.5747L226.009 72.5791C219.191 64.5501 211.06 59.5023 203.72 56.343C186.62 48.9652 168.681 49.4574 161.756 50.0083L161.268 50.0475C160.607 50.1065 159.949 50.1608 159.3 50.21C158.62 50.2657 157.963 50.3155 157.273 50.3672L156.808 50.405C149.888 50.9556 132.096 53.3178 116.375 63.3112C109.739 67.5216 102.643 73.6532 97.2215 82.4233L94.1418 43.8572C98.1148 42.3161 100.61 37.9669 99.3839 33.4214C98.4671 30.0211 95.4721 27.469 91.97 27.1062C86.3864 26.5264 81.9062 31.1246 82.3305 36.4436C82.6454 40.3623 85.5221 43.4702 89.1852 44.2546L92.3215 83.5139L92.317 83.5142C83.0838 84.2532 76.1985 92.3318 76.933 101.565L77.8222 112.713C78.0971 116.131 79.73 119.118 82.1506 121.18C83.8973 122.668 86.0455 123.672 88.3816 124.008C89.2985 124.149 90.2359 124.185 91.1931 124.108L93.3582 123.933L93.3512 123.821C90.838 92.359 105.935 75.8362 119.036 67.5159C133.815 58.116 150.648 55.8897 157.197 55.3666L157.635 55.3304C158.991 55.2328 160.36 55.1255 161.679 55.0077L162.144 54.9699C168.694 54.4468 185.672 53.9782 201.747 60.9116C216.001 67.0497 233.525 80.9739 236.038 112.431L236.045 112.543L238.524 112.345C239.374 112.279 240.196 112.124 240.982 111.9C243.372 111.212 245.44 109.839 246.99 108.016C249.052 105.596 250.193 102.391 249.918 98.9693L249.028 87.8213C248.303 78.5873 240.22 71.7022 230.986 72.4367ZM87.2915 36.046C87.1284 33.9971 88.6623 32.1982 90.7112 32.0351C92.7601 31.8721 94.5591 33.4059 94.7221 35.4548C94.8851 37.5037 93.3513 39.3027 91.3024 39.4657C89.2535 39.6288 87.4545 38.0949 87.2915 36.046ZM220.996 25.3709C220.833 23.322 222.366 21.523 224.415 21.36C226.464 21.197 228.263 22.7308 228.426 24.7797C228.589 26.8286 227.055 28.6276 225.006 28.7906C222.962 28.9534 221.163 27.4196 220.996 25.3709Z",
    fill: "#662D91"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M279.581 181.038L217.425 230.564C215.842 231.825 213.609 231.572 212.348 229.99L207.846 224.34C206.585 222.757 206.838 220.524 208.42 219.263L270.576 169.737C272.158 168.476 274.392 168.729 275.653 170.311L280.155 175.961C281.416 177.544 281.163 179.777 279.581 181.038Z",
    fill: "#6F5B9C"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M280.031 181.603L217.875 231.129C216.01 232.615 213.269 232.305 211.783 230.44L207.281 224.79C205.795 222.925 206.105 220.184 207.97 218.698L270.126 169.172C271.991 167.686 274.732 167.996 276.218 169.861L280.72 175.511C282.206 177.376 281.896 180.117 280.031 181.603ZM208.87 219.828C207.627 220.819 207.42 222.646 208.411 223.889L212.913 229.54C213.904 230.783 215.731 230.99 216.974 229.999L279.131 180.473C280.374 179.482 280.581 177.655 279.59 176.412L275.088 170.761C274.097 169.518 272.27 169.311 271.027 170.302L208.87 219.828Z",
    fill: "#6F5B9C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M159.421 189.39L138.575 196.355C137.825 196.605 137.09 197.521 137.109 198.181L137.403 208.643C137.424 209.366 137.825 209.87 138.44 209.912L156.262 211.066C157.866 211.171 159.248 210.201 159.475 208.798L162.421 190.413C162.597 189.308 161.072 188.839 159.421 189.39Z",
    fill: "#FFBD39"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6723 179.202L131.829 228.728C133.411 229.989 135.644 229.736 136.905 228.154L141.407 222.503C142.668 220.921 142.416 218.687 140.833 217.427L78.6771 167.9C77.0949 166.64 74.8612 166.892 73.6006 168.475L69.0982 174.125C67.8375 175.707 68.0901 177.941 69.6723 179.202Z",
    fill: "#6F5B9C"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M244.549 278.547H102.101C98.244 278.547 95.2133 276.387 95.2133 273.639V208.164C95.2133 205.416 98.244 203.256 102.101 203.256H244.411C248.268 203.256 251.299 205.416 251.299 208.164V273.639C251.437 276.289 248.268 278.547 244.549 278.547Z",
    fill: "#6F5B9C"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M244.421 195.911H102.096C98.2415 195.911 95.2133 198.948 95.2133 202.814V214.136C95.9015 214.274 96.7274 214.274 97.5532 214.274H248.963C249.789 214.274 250.477 214.136 251.303 214.136V202.814C251.303 198.948 248.137 195.911 244.421 195.911Z",
    fill: "#533867"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M193.501 245.637H151.753C147.856 245.637 144.795 242.576 144.795 238.679V234.087C144.795 230.191 147.856 227.129 151.753 227.129H193.501C197.398 227.129 200.459 230.191 200.459 234.087V238.679C200.459 242.576 197.398 245.637 193.501 245.637Z",
    fill: "#FCFCFC"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2042_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.254 201.032C142.254 201.032 141.151 203.893 142.544 196.973C143.379 192.828 144.816 194.442 143.56 194.546C143.56 194.546 142.776 200.909 145.022 187.852C153.247 185.1 146.135 187.345 145.022 187.852C139.786 188.059 124.247 172.462 114.756 179.221C109.478 182.981 109.545 189.171 110.744 192.031C111.245 193.231 112.011 194.225 112.85 195.076C117.081 199.363 123 200.092 128.591 200.33C130.558 200.413 132.494 200.62 134.475 200.846C136.806 201.11 139.152 201.371 141.521 201.631C144.688 201.978 139.015 200.691 142.254 201.032Z",
    fill: "#FAFAFA"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_2042_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.033 221.35L126.719 217.121C125.448 216.97 123.984 215.758 123.798 214.706L120.848 198.027C120.646 196.875 121.116 195.944 122.077 195.678L149.947 188.027C152.454 187.337 154.962 188.424 155.779 190.573L166.453 218.749C167.094 220.443 164.83 221.684 162.033 221.35Z",
    fill: "#FFBD39"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M148.395 204.396C148.967 205.892 149.461 207.407 149.87 208.939C150.094 209.701 150.268 210.473 150.47 211.24L150.99 213.559C151.622 216.663 151.968 219.243 151.392 219.531C150.24 219.531 150.44 216.919 149.757 213.825L149.287 211.495C149.158 210.712 149.002 209.937 148.896 209.149C148.65 207.581 148.483 205.997 148.395 204.396Z",
    fill: "#E28E07"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M148.395 204.396C148.967 205.892 149.461 207.407 149.87 208.939C150.094 209.701 150.268 210.473 150.47 211.24L150.99 213.559C151.622 216.663 151.968 219.243 151.392 219.531C150.24 219.531 150.44 216.919 149.757 213.825L149.287 211.495C149.158 210.712 149.002 209.937 148.896 209.149C148.65 207.581 148.483 205.997 148.395 204.396Z",
    fill: "#E28E07"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M134.993 203.816C135.565 205.312 136.059 206.827 136.468 208.359C136.692 209.121 136.865 209.893 137.067 210.661L137.588 212.979C138.22 216.083 138.566 218.663 137.989 218.951C136.837 218.951 137.038 216.34 136.355 213.245L135.885 210.916C135.756 210.133 135.6 209.357 135.494 208.569C135.248 207.002 135.081 205.417 134.993 203.816Z",
    fill: "#E28E07"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M134.993 203.816C135.565 205.312 136.059 206.827 136.468 208.359C136.692 209.121 136.865 209.893 137.067 210.661L137.588 212.979C138.22 216.083 138.566 218.663 137.989 218.951C136.837 218.951 137.038 216.34 136.355 213.245L135.885 210.916C135.756 210.133 135.6 209.357 135.494 208.569C135.248 207.002 135.081 205.417 134.993 203.816Z",
    fill: "#E28E07"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 237.285,
    cy: 222.44,
    rx: 25.4516,
    ry: 24.4727,
    transform: "rotate(-9.62857 237.285 222.44)",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.488 182.024C230.967 179.357 225.182 180.338 221.793 184.347L218.707 187.999C217.267 189.702 215.333 190.917 213.172 191.474L208.543 192.668C203.46 193.979 200.064 198.764 200.502 203.995L200.902 208.759C201.088 210.982 200.58 213.208 199.446 215.13L197.017 219.247C194.35 223.769 195.331 229.554 199.34 232.943L202.991 236.029C204.695 237.469 205.91 239.403 206.467 241.563L207.661 246.192C208.972 251.275 213.757 254.672 218.988 254.233L223.752 253.834C225.975 253.647 228.201 254.156 230.123 255.29L234.24 257.719C238.762 260.386 244.547 259.404 247.936 255.395L251.022 251.744C252.462 250.04 254.396 248.826 256.556 248.268L261.185 247.074C266.268 245.764 269.665 240.979 269.226 235.748L268.826 230.984C268.64 228.761 269.149 226.534 270.283 224.613L272.712 220.495C275.378 215.974 274.397 210.189 270.388 206.8L266.737 203.714C265.033 202.274 263.819 200.34 263.261 198.18L262.067 193.55C260.757 188.468 255.972 185.071 250.741 185.509L245.977 185.909C243.754 186.095 241.527 185.587 239.606 184.453L235.488 182.024ZM252.941 209.358C254.49 207.176 253.977 204.151 251.795 202.602C249.613 201.053 246.588 201.566 245.039 203.748L230.213 224.632L221.747 218.622C219.565 217.072 216.54 217.586 214.991 219.768C213.442 221.95 213.955 224.975 216.137 226.524L228.554 235.339C230.737 236.888 233.762 236.375 235.311 234.193L252.941 209.358Z",
    fill: "#77B255"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_2042_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.087 150.116C247.148 151.522 243.034 151.833 239.24 151.532C238.753 151.489 238.28 151.449 237.797 151.387C228.414 150.225 227.856 147.227 222.346 140.303C221.495 145.755 219.71 151.318 217.211 156.241C214.144 162.298 210.134 167.781 205.635 172.654C203.321 175.159 200.42 177.591 200.107 181.191C199.982 182.625 200.481 185.396 202.535 186.014C203.394 186.271 204.268 186.32 205.09 186.282C209.227 186.074 212.275 183.667 214.914 181.224C215.836 180.367 216.814 179.571 217.811 178.772C218.985 177.826 220.161 176.873 221.35 175.915C222.93 174.636 224.518 173.345 226.115 172.035C227.949 170.535 229.792 169.024 231.646 167.488C233.56 165.903 235.491 164.295 237.434 162.662C239.253 161.133 241.084 159.574 242.905 157.993C244.425 156.677 245.942 155.341 247.441 153.955C248.44 153.031 249.453 152.104 250.37 151.081C250.631 150.782 250.939 150.479 251.087 150.116Z",
    fill: "#FAFAFA"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M203.669 174.454C203.918 174.653 204.896 175.326 205.205 175.323C204.56 174.749 205.01 175.738 205.464 174.55C207.357 172.265 205.475 174.597 207.148 172.524C210.409 168.482 214.442 163.9 217.441 158.845C219.515 155.354 220.707 151.484 222.429 147.586C222.402 146.861 221.164 147.776 221.114 146.908C219.223 151.488 220.196 150.581 217.441 156.09C214.686 161.599 210.096 168.026 206.423 171.699C204.753 173.779 205.302 172.732 203.669 174.454C203.905 174.208 203.21 175.658 203.669 174.454Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M224.656 129.818L238.349 135.535C239.388 135.968 240.403 135.771 240.567 135.114L243.553 123.276C243.692 122.727 243.017 122.007 242.073 121.675L233.033 118.531C232.269 118.263 231.52 118.328 231.222 118.692L223.495 127.89C223.024 128.455 223.567 129.37 224.656 129.818Z",
    fill: "#FFBD39"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M241.889 137.221L254.925 143.123C256.252 143.723 257.514 143.463 257.612 142.571L259.385 127.13C259.463 126.478 258.652 125.63 257.569 125.222L249.384 122.124C248.393 121.752 247.455 121.85 247.178 122.356L240.341 134.892C239.951 135.602 240.653 136.663 241.889 137.221Z",
    fill: "#FFBD39"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M225.046 128.568L254.827 141.756C256.48 142.491 257.377 144.157 256.57 145.034L246.357 156.161C245.792 156.777 244.711 156.897 243.626 156.463L222.344 147.939C221.068 147.427 220.216 146.315 220.316 145.298L221.834 129.459C221.952 128.333 223.533 127.897 225.046 128.568Z",
    fill: "#FFBD39"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M257.171 144.319L223.114 129.248C222.52 128.982 222.201 128.494 222.398 128.145C222.595 127.803 223.237 127.741 223.826 127.999L257.582 142.908C258.194 143.176 258.597 143.712 258.485 144.101C258.373 144.49 257.784 144.588 257.171 144.319Z",
    fill: "#F4A525"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_2042_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.402 141.347L228.363 127.912C228.168 127.392 227.543 126.963 226.795 126.83L218.878 125.417C217.626 125.191 216.542 125.837 216.752 126.696L220.987 144.214C221.231 145.223 222.676 145.863 223.897 145.497L232.441 142.935C233.259 142.692 233.655 142.028 233.402 141.347Z",
    fill: "#FFBD39"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M229.605 142.526L222.069 146.221C221.563 146.372 220.957 146.178 220.72 145.788C220.483 145.399 220.696 144.961 221.202 144.81L228.705 141.195C229.162 141.062 229.737 141.245 229.984 141.609C230.232 141.974 230.063 142.386 229.605 142.526Z",
    fill: "#F4A525"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9723 218.068C76.6878 218.002 77.3167 218.187 77.8751 218.64C78.4334 219.092 78.7458 219.676 78.8124 220.391C78.879 221.107 78.6937 221.736 78.2414 222.294C77.789 222.852 77.2051 223.165 76.4896 223.231C75.7745 223.314 75.1452 223.113 74.5869 222.66C74.0286 222.208 73.7161 221.624 73.6495 220.909C73.5673 220.194 73.7682 219.564 74.2206 219.006C74.6729 218.448 75.2569 218.135 75.9723 218.068Z",
    fill: "#FFCA55"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1461 216.641C50.8616 216.574 51.4905 216.759 52.0488 217.212C52.6071 217.664 52.9196 218.248 52.9862 218.964C53.0528 219.679 52.8675 220.308 52.4151 220.866C51.9628 221.425 51.3788 221.737 50.6634 221.804C49.9483 221.886 49.319 221.685 48.7606 221.233C48.2023 220.78 47.8899 220.196 47.8233 219.481C47.7411 218.766 47.942 218.136 48.3943 217.578C48.8467 217.02 49.4306 216.707 50.1461 216.641Z",
    fill: "#FFCA55"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9874 222.428C29.7028 222.361 30.3317 222.546 30.8901 222.999C31.4484 223.451 31.7609 224.035 31.8275 224.75C31.8941 225.466 31.7087 226.095 31.2564 226.653C30.804 227.211 30.2201 227.524 29.5046 227.59C28.7895 227.673 28.1602 227.472 27.6019 227.019C27.0436 226.567 26.7311 225.983 26.6645 225.268C26.5823 224.553 26.7832 223.923 27.2356 223.365C27.6879 222.807 28.2719 222.494 28.9874 222.428Z",
    fill: "#A973D2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0523 239.263C31.7678 239.196 32.3967 239.381 32.955 239.834C33.5133 240.286 33.8258 240.87 33.8924 241.585C33.959 242.301 33.7737 242.93 33.3213 243.488C32.869 244.046 32.285 244.359 31.5695 244.426C30.8545 244.508 30.2252 244.307 29.6668 243.854C29.1085 243.402 28.7961 242.818 28.7295 242.103C28.6473 241.388 28.8482 240.758 29.3005 240.2C29.7529 239.642 30.3368 239.329 31.0523 239.263Z",
    fill: "#7ED957"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6301 254.875C53.3456 254.808 53.9745 254.994 54.5328 255.446C55.0912 255.898 55.4036 256.482 55.4702 257.198C55.5368 257.913 55.3515 258.542 54.8991 259.1C54.4468 259.659 53.8628 259.971 53.1474 260.038C52.4323 260.12 51.803 259.919 51.2447 259.467C50.6863 259.014 50.3739 258.43 50.3073 257.715C50.2251 257 50.426 256.371 50.8783 255.812C51.3307 255.254 51.9146 254.941 52.6301 254.875Z",
    fill: "#A973D2"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M69.939 244.584C70.6544 244.517 71.2833 244.702 71.8417 245.155C72.4 245.607 72.7125 246.191 72.7791 246.906C72.8456 247.622 72.6603 248.251 72.208 248.809C71.7556 249.368 71.1717 249.68 70.4562 249.747C69.7411 249.829 69.1118 249.628 68.5535 249.176C67.9952 248.723 67.6827 248.139 67.6161 247.424C67.5339 246.709 67.7348 246.079 68.1872 245.521C68.6395 244.963 69.2235 244.65 69.939 244.584Z",
    fill: "#A973D2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7318 255.062C90.4473 254.996 91.0762 255.181 91.6345 255.633C92.1928 256.086 92.5053 256.67 92.5719 257.385C92.6385 258.1 92.4532 258.729 92.0008 259.288C91.5485 259.846 90.9645 260.158 90.249 260.225C89.534 260.307 88.9047 260.106 88.3463 259.654C87.788 259.202 87.4756 258.618 87.409 257.902C87.3268 257.187 87.5277 256.558 87.98 256C88.4324 255.441 89.0163 255.129 89.7318 255.062Z",
    fill: "#FFCA55"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8033 232.941C55.5188 232.874 56.1477 233.059 56.706 233.512C57.2643 233.964 57.5768 234.548 57.6434 235.264C57.71 235.979 57.5247 236.608 57.0723 237.166C56.6199 237.725 56.036 238.037 55.3205 238.104C54.6055 238.186 53.9761 237.985 53.4178 237.533C52.8595 237.08 52.547 236.496 52.4804 235.781C52.3983 235.066 52.5991 234.436 53.0515 233.878C53.5039 233.32 54.0878 233.007 54.8033 232.941Z",
    fill: "#007AFF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5818 235.269C82.2973 235.203 82.9262 235.388 83.4846 235.84C84.0429 236.293 84.3553 236.877 84.4219 237.592C84.4885 238.308 84.3032 238.937 83.8509 239.495C83.3985 240.053 82.8146 240.366 82.0991 240.432C81.384 240.514 80.7547 240.314 80.1964 239.861C79.6381 239.409 79.3256 238.825 79.259 238.109C79.1768 237.394 79.3777 236.765 79.8301 236.207C80.2824 235.648 80.8664 235.336 81.5818 235.269Z",
    fill: "#7ED957"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7571 197.942C59.4726 197.875 60.1015 198.061 60.6598 198.513C61.2182 198.965 61.5306 199.549 61.5972 200.265C61.6638 200.98 61.4785 201.609 61.0262 202.168C60.5738 202.726 59.9899 203.038 59.2744 203.105C58.5593 203.187 57.93 202.986 57.3717 202.534C56.8133 202.082 56.5009 201.498 56.4343 200.782C56.3521 200.067 56.553 199.438 57.0054 198.879C57.4577 198.321 58.0416 198.009 58.7571 197.942Z",
    fill: "#7ED957"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0024 198.247C41.7179 198.18 42.3468 198.366 42.9051 198.818C43.4635 199.271 43.7759 199.854 43.8425 200.57C43.9091 201.285 43.7238 201.914 43.2715 202.473C42.8191 203.031 42.2352 203.343 41.5197 203.41C40.8046 203.492 40.1753 203.291 39.617 202.839C39.0586 202.387 38.7462 201.803 38.6796 201.087C38.5974 200.372 38.7983 199.743 39.2507 199.184C39.703 198.626 40.2869 198.314 41.0024 198.247Z",
    fill: "#FF5257"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M37.339 175.891C38.0545 175.824 38.6834 176.009 39.2417 176.462C39.8 176.914 40.1125 177.498 40.1791 178.214C40.2457 178.929 40.0604 179.558 39.608 180.116C39.1556 180.675 38.5717 180.987 37.8562 181.054C37.1412 181.136 36.5118 180.935 35.9535 180.483C35.3952 180.03 35.0827 179.446 35.0161 178.731C34.934 178.016 35.1348 177.386 35.5872 176.828C36.0396 176.27 36.6235 175.957 37.339 175.891Z",
    fill: "#A973D2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 272,
    y: 70,
    width: 61,
    height: 60
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M296.554 70.5115L332.315 96.4439L308.235 129.65L272.474 103.718L296.554 70.5115Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask23_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 180,
    y: 0,
    width: 204,
    height: 205
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M258.827 0.157445L383.539 77.4547L304.982 204.177L180.287 126.877L258.827 0.157445Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask24_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 180,
    y: 0,
    width: 204,
    height: 205
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M258.827 0.157445L383.539 77.4547L304.982 204.177L180.287 126.877L258.827 0.157445Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_2042_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.327 102.787C274.983 102.568 274.706 102.215 274.611 101.78C274.402 100.913 274.943 100.042 275.812 99.8503C279.155 99.0618 281.37 100.942 283.147 102.459C284.904 103.962 285.98 104.788 287.655 104.388C289.34 103.996 289.932 102.781 290.837 100.651C291.749 98.5116 292.894 95.8404 296.244 95.042C299.597 94.2608 301.804 96.1507 303.582 97.6679C305.346 99.1607 306.415 99.9965 308.09 99.5973C309.765 99.1981 310.357 97.983 311.272 95.8603C312.191 93.7105 313.327 91.0321 316.679 90.2509C320.022 89.4624 322.239 91.3596 324.016 92.8768C325.771 94.3623 326.847 95.1882 328.525 94.8062C329.392 94.5975 330.263 95.1382 330.462 95.9978C330.663 96.8747 330.13 97.7363 329.263 97.945C325.91 98.7263 323.703 96.8363 321.918 95.3291C320.161 93.8264 319.085 93.0005 317.418 93.3898C315.743 93.789 315.143 95.0141 314.236 97.1267C313.316 99.2765 312.181 101.955 308.828 102.736C305.485 103.525 303.261 101.637 301.484 100.12C299.736 98.6247 298.66 97.7989 296.975 98.1908C295.308 98.5801 294.709 99.8052 293.811 101.925C292.891 104.075 291.746 106.746 288.393 107.527C285.051 108.316 282.836 106.436 281.059 104.919C279.301 103.416 278.226 102.59 276.551 102.989C276.116 103.085 275.688 103.003 275.327 102.787Z",
    fill: "#5271FF"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 262,
    y: 44,
    width: 36,
    height: 52
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M279.894 44.3147L297.463 51.368L279.83 95.2896L262.261 88.2363L279.894 44.3147Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask26_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 8,
    width: 186,
    height: 188
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M233.777 8.69381L373.543 53.3435L328.16 195.365L188.411 150.708L233.777 8.69381Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask27_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 8,
    width: 186,
    height: 188
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M233.777 8.69381L373.543 53.3435L328.16 195.365L188.411 150.708L233.777 8.69381Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_2042_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.004 89.2244C266.601 89.1026 266.24 88.8114 266.046 88.4015C265.653 87.5931 265.989 86.6254 266.793 86.2442C279.874 79.9278 289.228 67.6124 291.804 53.3201C291.959 52.4392 292.802 51.8612 293.678 52.0271C294.548 52.177 295.137 53.0245 294.976 53.8895C293.621 61.4338 290.451 68.6347 285.824 74.733C281.186 80.8266 275.092 85.8175 268.192 89.1435C267.809 89.3353 267.391 89.353 267.004 89.2244Z",
    fill: "#7ED957"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 257,
    y: 70,
    width: 12,
    height: 10
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M259.355 70.0693L268.139 73.596L265.788 79.4522L257.004 75.9256L259.355 70.0693Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask29_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 8,
    width: 186,
    height: 188
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M233.778 8.69405L373.544 53.3438L328.161 195.365L188.412 150.708L233.778 8.69405Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask30_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 8,
    width: 186,
    height: 188
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M233.778 8.69405L373.544 53.3438L328.161 195.365L188.412 150.708L233.778 8.69405Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_2042_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.701 74.6194C264.524 75.1593 264.191 75.5571 263.687 75.8197C263.184 76.0822 262.662 76.1251 262.122 75.9482C261.582 75.7712 261.184 75.4389 260.921 74.935C260.659 74.4312 260.616 73.9093 260.782 73.3648C260.958 72.8248 261.291 72.427 261.806 72.169C262.31 71.9065 262.832 71.8636 263.372 72.0406C263.916 72.206 264.31 72.5498 264.572 73.0537C264.835 73.5576 264.877 74.0795 264.701 74.6194Z",
    fill: "#662D91"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 295,
    y: 72,
    width: 11,
    height: 12
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M299.194 72.4633L305.05 74.8144L301.524 83.5987L295.668 81.2476L299.194 72.4633Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask32_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 8,
    width: 186,
    height: 188
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M233.777 8.69381L373.543 53.3435L328.16 195.365L188.411 150.708L233.777 8.69381Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask33_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 8,
    width: 186,
    height: 188
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M233.777 8.69381L373.543 53.3435L328.16 195.365L188.411 150.708L233.777 8.69381Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_2042_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.324 78.7374C301.147 79.2773 300.814 79.6752 300.299 79.9331C299.795 80.1957 299.273 80.2385 298.733 80.0616C298.193 79.8847 297.796 79.5523 297.533 79.0485C297.27 78.5446 297.228 78.0227 297.405 77.4828C297.582 76.9429 297.914 76.5451 298.418 76.2825C298.922 76.0199 299.443 75.9771 299.983 76.154C300.528 76.3195 300.933 76.6679 301.184 77.1672C301.446 77.671 301.489 78.1929 301.324 78.7374Z",
    fill: "#5271FF"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 276,
    y: 85,
    width: 11,
    height: 12
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M280.429 85.33L286.285 87.6811L282.759 96.4654L276.902 94.1143L280.429 85.33Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask35_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 8,
    width: 186,
    height: 188
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M233.778 8.69381L373.544 53.3435L328.161 195.365L188.412 150.708L233.778 8.69381Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask36_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 8,
    width: 186,
    height: 188
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M233.778 8.69381L373.544 53.3435L328.161 195.365L188.412 150.708L233.778 8.69381Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_2042_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.839 91.5594C283.662 92.0993 283.329 92.4971 282.825 92.7597C282.322 93.0223 281.8 93.0651 281.26 92.8882C280.72 92.7113 280.322 92.3789 280.059 91.875C279.797 91.3712 279.754 90.8493 279.931 90.3094C280.096 89.7649 280.44 89.3716 280.944 89.1091C281.448 88.8465 281.97 88.8037 282.51 88.9806C283.054 89.1461 283.448 89.4899 283.71 89.9937C283.973 90.4976 284.016 91.0195 283.839 91.5594Z",
    fill: "#FFCA55"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 279,
    y: 26,
    width: 17,
    height: 22
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M286.948 26.7463L295.732 30.273L288.679 47.8416L279.894 44.315L286.948 26.7463Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask38_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 8,
    width: 186,
    height: 188
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M233.777 8.69381L373.543 53.3435L328.16 195.365L188.411 150.708L233.777 8.69381Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask39_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 8,
    width: 186,
    height: 188
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M233.777 8.69381L373.543 53.3435L328.16 195.365L188.411 150.708L233.777 8.69381Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_2042_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.657 45.5601C283.129 45.3877 282.701 44.9638 282.572 44.3937C282.367 43.5146 282.91 42.657 283.778 42.4475C285.005 42.1698 286.073 41.1642 286.415 39.947C286.572 39.4253 286.616 38.8189 286.658 38.1849C286.723 37.4274 286.79 36.5647 287.041 35.709C287.588 33.8833 288.943 32.3286 290.681 31.5389C291.485 31.1577 292.443 31.516 292.82 32.3313C293.185 33.1419 292.831 34.089 292.016 34.4656C291.137 34.8696 290.419 35.6973 290.137 36.633C289.98 37.1546 289.931 37.7725 289.88 38.4293C289.824 39.164 289.755 39.9993 289.509 40.8435C288.837 43.1772 286.878 45.0469 284.506 45.5955C284.213 45.6638 283.925 45.6542 283.657 45.5601Z",
    fill: "#FFCA55"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 315,
    y: 49,
    width: 13,
    height: 13
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M318.558 49.6372L327.342 53.1639L323.816 61.9482L315.031 58.4215L318.558 49.6372Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask41_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 8,
    width: 186,
    height: 188
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M233.777 8.69405L373.543 53.3438L328.16 195.365L188.411 150.708L233.777 8.69405Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask42_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 8,
    width: 186,
    height: 188
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M233.777 8.69405L373.543 53.3438L328.16 195.365L188.411 150.708L233.777 8.69405Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_2042_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.539 57.0836C319.148 56.9664 318.809 56.6844 318.595 56.2928C318.198 55.4958 318.505 54.5303 319.296 54.1171L322.914 52.2495C323.704 51.8362 324.681 52.1487 325.095 52.9388C325.503 53.7404 325.195 54.7059 324.394 55.1146L320.775 56.9822C320.377 57.1808 319.937 57.2168 319.539 57.0836Z",
    fill: "#5271FF"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 302,
    y: 54,
    width: 14,
    height: 14
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M306.247 54.8949L315.032 58.4215L311.505 67.2059L302.721 63.6792L306.247 54.8949Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask44_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 8,
    width: 186,
    height: 188
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M233.777 8.69381L373.543 53.3435L328.16 195.365L188.411 150.708L233.777 8.69381Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask45_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 8,
    width: 186,
    height: 188
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M233.777 8.69381L373.543 53.3435L328.16 195.365L188.411 150.708L233.777 8.69381Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_2042_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.641 63.7391C306.25 63.6219 305.9 63.3354 305.696 62.9483C305.288 62.1467 305.596 61.1813 306.386 60.768L310.016 58.905C310.806 58.4917 311.783 58.8042 312.185 59.5898C312.593 60.3914 312.286 61.3568 311.495 61.7701L307.877 63.6377C307.474 63.8478 307.027 63.8678 306.641 63.7391Z",
    fill: "#5271FF"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 314,
    y: 59,
    width: 13,
    height: 13
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M317.96 59.5972L326.745 63.1238L323.218 71.9081L314.434 68.3815L317.96 59.5972Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask47_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 8,
    width: 186,
    height: 188
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M233.777 8.69405L373.543 53.3438L328.16 195.365L188.411 150.708L233.777 8.69405Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask48_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 8,
    width: 186,
    height: 188
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M233.777 8.69405L373.543 53.3438L328.16 195.365L188.411 150.708L233.777 8.69405Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_2042_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.591 68.5667C319.2 68.4495 318.85 68.163 318.647 67.7759L316.784 64.1459C316.371 63.3557 316.683 62.3788 317.469 61.977C318.27 61.5683 319.236 61.8763 319.649 62.6664L321.512 66.2964C321.925 67.0866 321.613 68.0635 320.827 68.4653C320.424 68.6753 319.978 68.6954 319.591 68.5667Z",
    fill: "#5271FF"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 306,
    y: 46,
    width: 13,
    height: 13
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M309.774 46.1106L318.558 49.6372L315.032 58.4216L306.247 54.8949L309.774 46.1106Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask50_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 8,
    width: 186,
    height: 188
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M233.777 8.69405L373.543 53.3438L328.16 195.365L188.411 150.708L233.777 8.69405Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask51_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 8,
    width: 186,
    height: 188
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M233.777 8.69405L373.543 53.3438L328.16 195.365L188.411 150.708L233.777 8.69405Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_2042_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.086 54.0122C311.683 53.8903 311.345 53.6084 311.142 53.2213L309.279 49.5913C308.866 48.8012 309.178 47.8243 309.964 47.4224C310.754 47.0092 311.731 47.3217 312.144 48.1118L314.007 51.7419C314.42 52.532 314.108 53.5089 313.311 53.9061C312.919 54.1208 312.473 54.1408 312.086 54.0122Z",
    fill: "#5271FF"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 257,
    y: 47,
    width: 17,
    height: 17
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M261.728 47.2214L273.44 51.9236L268.738 63.6361L257.026 58.9339L261.728 47.2214Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask53_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 8,
    width: 186,
    height: 188
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M233.778 8.69405L373.544 53.3438L328.161 195.365L188.412 150.708L233.778 8.69405Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_2042_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask54_2042_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 8,
    width: 186,
    height: 188
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M233.778 8.69405L373.544 53.3438L328.161 195.365L188.412 150.708L233.778 8.69405Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_2042_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.564 56.374C270.348 57.0443 270.015 57.6413 269.562 58.1763C269.108 58.7113 268.578 59.1363 267.958 59.4582C267.342 59.7687 266.678 59.967 265.991 60.0233C265.293 60.0751 264.606 59.9987 263.947 59.7873C263.289 59.5759 262.68 59.2387 262.152 58.8009C261.617 58.347 261.197 57.8063 260.875 57.1857C260.553 56.565 260.361 55.9171 260.31 55.2189C260.246 54.5162 260.318 53.8411 260.534 53.1708C260.746 52.5119 261.078 51.9149 261.532 51.38C261.986 50.845 262.515 50.4199 263.136 50.098C263.756 49.7761 264.416 49.5892 265.114 49.5375C265.801 49.4811 266.487 49.5575 267.146 49.7689C267.816 49.9849 268.418 50.3061 268.942 50.7554C269.477 51.2092 269.902 51.7384 270.223 52.3591C270.541 52.9912 270.732 53.6392 270.795 54.3419C270.847 55.04 270.775 55.7151 270.564 56.374Z",
    fill: "#F7A941"
  }))))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M324.098 80.3776C323.923 80.9223 323.652 81.4074 323.284 81.8422C322.915 82.277 322.485 82.6224 321.98 82.884C321.48 83.1363 320.94 83.2975 320.382 83.3432C319.815 83.3853 319.257 83.3232 318.721 83.1514C318.186 82.9796 317.691 82.7056 317.262 82.3498C316.828 81.981 316.486 81.5416 316.224 81.0372C315.963 80.5328 315.807 80.0062 315.765 79.4389C315.714 78.8678 315.772 78.3192 315.947 77.7744C316.119 77.239 316.39 76.7539 316.758 76.3191C317.127 75.8843 317.557 75.5389 318.062 75.2773C318.566 75.0157 319.102 74.8638 319.669 74.8218C320.227 74.776 320.785 74.8381 321.321 75.0099C321.865 75.1854 322.354 75.4464 322.78 75.8115C323.215 76.1803 323.56 76.6104 323.822 77.1148C324.079 77.6285 324.235 78.1551 324.286 78.7261C324.328 79.2935 324.27 79.8421 324.098 80.3776Z",
    fill: "#7ED957"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2042_2",
    x: 123.672,
    y: 163.84,
    width: 92.1381,
    height: 88.465,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.83635
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2042_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2042_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2042_2",
    x: 95.8525,
    y: 58.7825,
    width: 138.621,
    height: 112.367,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.83635
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2042_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2042_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2042_2",
    x: 63.5929,
    y: -54.3156,
    width: 201.262,
    height: 253.478,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -77.1268
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.67271
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2042_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2042_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2042_2",
    x: 108.242,
    y: 177.521,
    width: 40.6962,
    height: 24.1693,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.83635
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2042_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2042_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_2042_2",
    x: 118.965,
    y: 187.821,
    width: 47.5975,
    height: 35.4207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.83635,
    dy: 1.83635
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2042_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2042_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_2042_2",
    x: 200.089,
    y: 138.467,
    width: 54.6705,
    height: 47.827,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.67271,
    dy: -1.83635
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2042_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2042_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_2042_2",
    x: 216.26,
    y: 124.906,
    width: 17.6834,
    height: 21.1613,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.232857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2042_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2042_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2042_2",
    x1: 214.122,
    y1: 206.125,
    x2: 123.78,
    y2: 207.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2042_2",
    x1: 158.089,
    y1: 33.8189,
    x2: 170.28,
    y2: 195.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980696,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2042_2",
    x1: 159.313,
    y1: 50.0697,
    x2: 168.249,
    y2: 168.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0212642,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.978736,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2042_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 225.871,
    height: 279.126,
    fill: "white",
    transform: "translate(60.543)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfinandinhoCadastroSucesso);
export default __webpack_public_path__ + "static/media/afinandinho-cadastro-sucesso.a9daf2a6405c9f56895bde3b15585872.svg";
export { ForwardRef as ReactComponent };